




import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { countable, easeOutCubic, interpolateText } from "@/utils/MiraNumberTween";

const DURATION_MS = 450;

/**
 * A text whose numbers count to their new values when it changes, instead of switching at once
 * (Mira tiles, Taimoor 2026-09-30). Nothing overlaps while it counts, so the width moves with the
 * digits rather than jumping when a cross-fade ends, which is what moved the neighbouring text before.
 * A text whose words change as well swaps at once; `prefers-reduced-motion` always swaps.
 */
@Component
export default class MiraAnimatedTextComponent extends Vue {
  @Prop({ required: true })
  text!: string;

  shown = "";
  frame: number | null = null;

  created() {
    this.shown = this.text;
  }

  beforeDestroy() {
    this.cancel();
  }

  @Watch("text")
  onTextChanged(to: string) {
    this.cancel();
    const from = this.shown;
    const locale = this.$i18n?.locale ?? "de";
    const reduced = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

    if (reduced || !countable(from, to, locale)) {
      this.shown = to;
      return;
    }

    const start = performance.now();
    const step = (now: number) => {
      const progress = (now - start) / DURATION_MS;
      this.shown = interpolateText(from, to, easeOutCubic(progress), locale);
      this.frame = progress < 1 ? requestAnimationFrame(step) : null;
    };
    this.frame = requestAnimationFrame(step);
  }

  cancel() {
    if (this.frame !== null) {
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  }
}
